import { defineStore } from 'pinia';
import QuoteService from '@/services/quote.service.js';

const PAGE_SIZE = 10;

export const useQuotesStore = defineStore('quotes', {
  state: () => ({
    quotes: [],
    before: null, // id de la última cita cargada; null = primera página
    hasNext: true,
    loading: false,
    error: null,
    total: null, // total de citas en la base de datos, según el backend
  }),
  actions: {
    async fetchNextPage() {
      if (this.loading || !this.hasNext) return;

      this.loading = true;
      this.error = null;

      try {
        const { quotes, hasNext, nextCursor, total } = await QuoteService.getQuotes({
          before: this.before,
          limit: PAGE_SIZE,
        });

        this.quotes.push(...quotes);
        this.hasNext = hasNext;
        this.total = total;
        if (quotes.length) {
          this.before = nextCursor;
        }
      } catch (err) {
        this.error =
          err?.response?.data?.message || err.message || 'No se pudieron cargar las frases.';
      } finally {
        this.loading = false;
      }
    },
    // Pide solo el total actualizado sin tocar la paginación ya cargada.
    // Se usa al volver a una vista cuyo store ya tenía citas en caché
    // (fetchNextPage() no se repite en ese caso, así que sin esto el
    // total se quedaría con el valor de la última página visitada).
    async refreshTotal() {
      try {
        const { total } = await QuoteService.getQuotes({ limit: 1 });
        this.total = total;
      } catch {
        // No es crítico: si falla, el total simplemente no se actualiza esta vez.
      }
    },
    // Actualiza una cita ya editada en el backend, sin recargar el feed entero.
    updateQuote(id, changes) {
      const index = this.quotes.findIndex((q) => q.id === id);
      if (index !== -1) {
        this.quotes[index] = { ...this.quotes[index], ...changes };
      }
    },
    // Quita una cita ya eliminada en el backend sin recargar el feed entero.
    removeQuote(id) {
      this.quotes = this.quotes.filter((q) => q.id !== id);
    },
    // Para cuando se cree una cita nueva y haya que volver a empezar desde arriba.
    reset() {
      this.quotes = [];
      this.before = null;
      this.hasNext = true;
      this.error = null;
      this.total = null;
    },
  },
});